export const mirrorRtl = {'[dir="rtl"] &': {transform: 'scaleX(-1)'}} as const;
